import React, { useEffect, useState } from "react";
import { TableSortLabel } from "@mui/material";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { Header } from "../../../../Components/Header";
import { Panel } from "../../../../Components/Panel";
import { useImovel, IImovelFormatado } from "../../../../Hooks/imoveis";
import { Container, AddImovelButton } from "./styles";
import { Alert } from "../../../../Components/Error/Alert";
import { ModalLoader } from "../../../../Components/ModalLoader";
import api from "../../../../Services/api";
import { Home, Plus } from "react-feather";
import { AddImovelForm } from "../../../../Components/AddImovelForm";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { useNavigate } from "react-router";
import CeleiroLogo from "../../../../Assets/celeiro.png";
import { ImprimirDialogImoveisRurais } from "./ImprimirDialog";
import { app_base_url, app_full_url } from "../../../../Utils/baseUrl";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import theme from "../../../../Styles/theme";
import { Link } from "react-router-dom";

export function ImoveisPrefeituraRural() {
  const { newImovel, filtro, handleSetNewImovel } = useImovel();
  const navigate = useNavigate();
  const {
    checarTokenPrefeitura,
    prefeituraIsLogged,
    prefeitura,
  } = usePrefeitura();

  const [index, setIndex] = useState<2 | 3>(2);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ title: "", message: "" });
  const [imoveisPendentes, setImoveisPendentes] = useState<IImovelFormatado[]>(
    []
  );
  const [imoveisEnviados, setImoveisEnviados] = useState<IImovelFormatado[]>(
    []
  );
  const [imoveisAvaliados, setImoveisAvaliados] = useState<IImovelFormatado[]>(
    []
  );
  const [addImovelForm, setAddImovelForm] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear()
  );
  const [orderBy, setOrderBy] = useState("NUMERO");
  const [order, setOrder] = useState<"asc" | "desc">("desc");

  const [openPrint, setOpenPrint] = useState(false);

  useEffect(() => {
    if (newImovel.ID) {
      setImoveisPendentes((prev) => [newImovel, ...prev]);
      handleSetNewImovel({} as IImovelFormatado);
      navigate(`${app_base_url}/imovel-rural/${newImovel.ID}`);
    }
  }, [newImovel, handleSetNewImovel, navigate]);

  function exportarCSV() {
    const imoveis = sortedImoveis();

    const headers = [
      "Codigo",
      "Cartorio",
      "Localizacao",
      "Transmitente",
      "Adquirente",
      "Criado",
      "Enviado",
      "Avaliado",
    ];

    const rows = imoveis.map((imovel) => [
      imovel.NUMERO + "/" + new Date(imovel.DATA_CRIACAO).getFullYear(),
      imovel.CARTORIO_TITULO || "",
      imovel.LOCALIZACAO || "",
      imovel.TRANSMITENTE || "",
      imovel.ADQUIRINTE || "",
      imovel.DATA_CRIACAO
        ? new Date(imovel.DATA_CRIACAO).toLocaleDateString("pt-BR")
        : "",
      imovel.ENVIADO
        ? new Date(imovel.ENVIADO).toLocaleDateString("pt-BR")
        : "",
      imovel.AVALIADO
        ? new Date(imovel.AVALIADO).toLocaleDateString("pt-BR")
        : "",
    ]);

    const csv = [headers, ...rows]
      .map((row) => row.map((v) => `"${v}"`).join(";"))
      .join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "imoveis_rurais_" + selectedYear + ".csv";
    link.click();

    URL.revokeObjectURL(url);
  }


   useEffect(() => {
     //if (filtro) {
       setImoveisEnviados([]);
       setImoveisAvaliados([]);
       fetchImoveis("enviados", setImoveisEnviados);
       fetchImoveis("avaliados", setImoveisAvaliados);
    // }
   }, [filtro, selectedYear]);


  async function fetchImoveis(
    situacao: string,
    setImoveis: React.Dispatch<React.SetStateAction<IImovelFormatado[]>>
  ) {
    try {
      setLoading(true);
      const response = await api.get<IImovelFormatado[]>(
        `/imovel-rural/${situacao}/prefeitura/${prefeitura.ID}/${selectedYear}`
      );
      setImoveis(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }



  const years = [2026, 2025, 2024, 2023, 2022];

  const sortedImoveis = () => {
    const imoveis = index === 2 ? imoveisEnviados : imoveisAvaliados;
    return imoveis
      .filter(
        (imovel) =>
          new Date(imovel.DATA_CRIACAO).getFullYear() === selectedYear
      )
      .filter((imovel) =>
        filterText === ""
          ? true
          : Object.values(imovel).some((value) =>
            value
              ? value
                .toString()
                .toLowerCase()
                .includes(filterText.toLowerCase())
              : false
          )
      )
      .slice()
      .sort((a: Record<string, any>, b: Record<string, any>) => {
        const aValue = a[orderBy];
        const bValue = b[orderBy];

        if (aValue === null || aValue === undefined) return 1;
        if (bValue === null || bValue === undefined) return -1;

        if (order === "asc") {
          if (aValue < bValue) return -1;
          if (aValue > bValue) return 1;
        } else {
          if (aValue > bValue) return -1;
          if (aValue < bValue) return 1;
        }

        return 0;
      });
  };

  function handleSort(property: string) {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  }


  return (
    <Container>
      <MenuLateral titulo={prefeitura.NOME} />
      <Panel>
        {addImovelForm ? (
          <AddImovelForm
            rural={true}
            handleClose={() => setAddImovelForm(false)}
          />
        ) : (
          <>
            <Header type={"IMÓVEIS RURAIS"} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <Button
                variant="contained"
                color={index === 2 ? "primary" : "inherit"}
                onClick={() => {
                  setIndex(2);
                  fetchImoveis("enviados", setImoveisAvaliados);
                }}
                style={{ marginRight: "8px" }}
              >
                Pendentes
              </Button>
              <Button
                variant="contained"
                color={index === 3 ? "primary" : "inherit"}
                onClick={() => {
                  setIndex(3);
                  fetchImoveis("avaliados", setImoveisAvaliados);
                }}
              >
                Avaliados
              </Button>
              {/* Adicionando o campo de texto para filtrar */}
              <TextField
                label="Filtrar"
                variant="outlined"
                size="small"
                style={{ marginLeft: "8px" }}
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {/* Adicionando o seletor de ano */}
              <FormControl
                variant="outlined"
                size="small"
                style={{ marginLeft: "8px" }}
              >
                <InputLabel id="select-year-label">Ano</InputLabel>
                <Select
                  labelId="select-year-label"
                  id="select-year"
                  value={selectedYear}
                  onChange={(event) =>
                    setSelectedYear(event.target.value as number)
                  }
                  label="Ano"
                >
                  {/* Renderize aqui as opções de ano */}
                  {/* <MenuItem value="">Todos</MenuItem> */}
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="outlined"
                style={{ marginLeft: "8px" }}
                onClick={() => setOpenPrint(true)}
              >
                Imprimir
              </Button>
              <Button
                variant="outlined"
                style={{ marginLeft: "8px" }}
                onClick={exportarCSV}
              >
                Exportar CSV
              </Button>
            </div>
            <Paper
              style={{
                padding: "16px",
                backgroundColor: "#fff",
                height: "70vh",
                overflowY: "auto",
                width: "92vw",
              }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {[
                        { label: "Código", field: "NUMERO" },
                        { label: "Cartório", field: "CARTORIO_TITULO" },
                        { label: "Localização", field: "LOCALIZACAO" },
                        { label: "Transmitente", field: "TRANSMITENTE" },
                        { label: "Adquirente", field: "ADQUIRINTE" },
                        { label: "Criado", field: "DATA_CRIACAO" },
                        { label: "Enviado", field: "ENVIADO" },
                        { label: "Avaliado", field: "AVALIADO" },
                      ].map((col) => (
                        <TableCell key={col.field} align="center">
                          <TableSortLabel
                            active={orderBy === col.field}
                            direction={orderBy === col.field ? order : "asc"}
                            onClick={() => handleSort(col.field)}
                          >
                            <Typography variant="h6">{col.label}</Typography>
                          </TableSortLabel>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedImoveis().map((imovel) => (
                      <TableRow hover key={imovel.ID}>
                        <TableCell>
                          {imovel.NUMERO}/
                          {new Date(imovel.DATA_CRIACAO).getFullYear()}
                        </TableCell>
                        <TableCell>{imovel.CARTORIO_TITULO}</TableCell>
                        <TableCell>{imovel.LOCALIZACAO}</TableCell>
                        <TableCell>{imovel.TRANSMITENTE}</TableCell>
                        <TableCell>{imovel.ADQUIRINTE}</TableCell>
                        <TableCell>
                          {imovel.DATA_CRIACAO
                            ? new Date(imovel.DATA_CRIACAO).toLocaleDateString("pt-BR")
                            : ""}
                        </TableCell>

                        <TableCell>
                          {imovel.ENVIADO
                            ? new Date(imovel.ENVIADO).toLocaleDateString("pt-BR")
                            : ""}
                        </TableCell>

                        <TableCell>
                          {imovel.AVALIADO
                            ? new Date(imovel.AVALIADO).toLocaleDateString("pt-BR")
                            : ""}
                        </TableCell>
                        <TableCell align="center">
                          <a
                            href={`${app_full_url}/imovel-rural/${imovel.ID}`}
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: theme.colors.primary,
                            }}
                          >
                            Visualizar
                          </a>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            <Alert
              title={error.title}
              message={error.message}
              open={error.message.length > 0}
              onClose={() => setError({ title: "", message: "" })}
            />
            <ModalLoader loading={loading} />
            <br />
            <AddImovelButton onClick={() => setAddImovelForm(true)}>
              <img src={CeleiroLogo} style={{ width: "max(18px, 1.5vw)" }} />
              <Plus size={"max(12px, 1.2vw)"} />
            </AddImovelButton>
          </>
        )}
      </Panel>
      <ImprimirDialogImoveisRurais
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        dados={sortedImoveis()}
        filtros={{
          ano: selectedYear,
          texto: filterText,
          situacao: index === 2 ? "Pendentes" : "Avaliados",
        }}
      />
    </Container>
  );
}
